var map = {
	"./de/news.json": [
		75019,
		1736
	],
	"./de/statementGlossary.json": [
		76007,
		6007
	],
	"./de/web.json": [
		53343,
		3343
	],
	"./en/news.json": [
		90818,
		8157
	],
	"./en/statementGlossary.json": [
		22479,
		2479
	],
	"./en/web.json": [
		75339,
		5339
	],
	"./es/news.json": [
		13574,
		5759
	],
	"./es/statementGlossary.json": [
		6924,
		6924
	],
	"./es/web.json": [
		6476,
		6476
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 36350;
module.exports = webpackAsyncContext;